module.exports = __webpack_public_path__ + "static/media/SWSCRC6-9.74f8e682.mp3";